import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle, faExclamationTriangle, faInfoCircle, faTimes } from '@fortawesome/pro-light-svg-icons';
import { SnackbarOrigin } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import React from 'react';

import Icon from '../../../components/Icon';
import Notifier from '../Notifier';

export interface INotificationProviderProps {
    children?: React.ReactNode;
}

const snackBarOrigin: SnackbarOrigin = {
    vertical: 'top',
    horizontal: 'right',
};

const iconVariant = {
    success: <Icon icon={faCheckCircle} />,
    error: <Icon icon={faTimes} />,
    warning: <Icon icon={faExclamationTriangle} />,
    info: <Icon icon={faInfoCircle} />,
    default: <Icon icon={faHeart} iconColor="error" />,
};

export const NotificationProvider = (props: INotificationProviderProps) => {
    const { children } = props;
    return (
        <SnackbarProvider 
            anchorOrigin={snackBarOrigin} 
            iconVariant={iconVariant} 
            maxSnack={4} 
            autoHideDuration={3000}
        >
            <Notifier />
            {children}
        </SnackbarProvider>
    );
};

export default NotificationProvider;
